/* Harriet Chelsea – Black Friday layout: theme-owned scripts moved out of inline <script> tags (performance).
   Loaded with defer from layout/theme.liquid.
   1) Early Black Friday countdown (was in snippets/hcbf-style.liquid)
   2) Tiers strip rotation (was in sections/hcbf-tiers-strip.liquid; speed comes from data-hcbf-tiers-speed)
   3) PDP dispatch window (was in snippets/hcbf-pdp-dispatch.liquid) */

/* 1) Early Black Friday countdown (real end date from the announcement section setting "Campaign end date").
   Every element with [data-hcbf-cd] gets "2d 13:45:12"; its wrapper [data-hcbf-cd-wrap] stays hidden
   until a valid future end date is known and is hidden again once the date has passed. */
(function () {
  if (window.__hcbfCd) return;
  window.__hcbfCd = true;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function endTime() {
    var src = document.querySelector('[data-hcbf-end]');
    if (!src) return NaN;
    var v = (src.getAttribute('data-hcbf-end') || '').trim();
    return v ? Date.parse(v) : NaN;
  }
  function tick() {
    var end = endTime();
    var left = isNaN(end) ? -1 : Math.floor((end - Date.now()) / 1000);
    var wraps = document.querySelectorAll('[data-hcbf-cd-wrap]');
    for (var i = 0; i < wraps.length; i++) {
      if (left > 0) wraps[i].removeAttribute('hidden'); else wraps[i].setAttribute('hidden', '');
    }
    if (left <= 0) return;
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    var txt = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    var els = document.querySelectorAll('[data-hcbf-cd]');
    for (var j = 0; j < els.length; j++) { if (els[j].textContent !== txt) els[j].textContent = txt; }
  }
  window.hcbfCountdownTick = tick;
  function start() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  ['cart:updated', 'cart:refresh', 'shopify:section:load'].forEach(function (e) { document.addEventListener(e, function () { setTimeout(tick, 30); }); });
})();

/* 2) Tiers strip: rotates the messages of every [data-hcbf-tiers] strip (only rendered with 2+ blocks). */
(function () {
  function initTiers(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    var msgs = root.querySelectorAll('.hcbf-tiers__msg');
    if (msgs.length < 2) return;
    var speed = parseInt(root.getAttribute('data-hcbf-tiers-speed'), 10) || 3000;
    var i = 0;
    setInterval(function () {
      var cur = msgs[i];
      i = (i + 1) % msgs.length;
      var nxt = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-off');
      nxt.classList.remove('is-off'); nxt.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-off'); }, 500);
    }, speed);
  }
  function initAll() {
    var roots = document.querySelectorAll('[data-hcbf-tiers]');
    for (var k = 0; k < roots.length; k++) initTiers(roots[k]);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

/* 3) PDP dispatch window computed in the visitor's browser: 1–2 working days
   (weekends, 25/26 Dec and 1 Jan skipped). */
(function () {
  function initDispatch() {
    var box = document.querySelector('[data-hcbf-dispatch]:not([data-ready])');
    if (!box) return;
    box.setAttribute('data-ready', '1');
    function off(d) { var w = d.getDay(); var md = (d.getMonth() + 1) + '-' + d.getDate(); return w === 0 || w === 6 || md === '12-25' || md === '12-26' || md === '1-1'; }
    function addWorking(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); if (!off(x)) n--; } return x; }
    function fmt(d) { try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString(); } }
    var now = new Date();
    var el = box.querySelector('[data-hcbf-dispatch-date]');
    if (el) el.textContent = ' (' + fmt(addWorking(now, 1)) + ' – ' + fmt(addWorking(now, 2)) + ')';
    if (window.hcbfCountdownTick) window.hcbfCountdownTick();
  }
  initDispatch();
  document.addEventListener('shopify:section:load', initDispatch);
})()